import { rem } from './rem';
import { colors } from './colors';

export const fixedBottom = {
  actionBarBackground: colors.components.fixedBottom.ActionBar.Background.Default,
  declarationDrawerBodyBackground:
    colors.components.fixedBottom.DeclarationDrawer.Background.Body,
  declarationDrawerCollapsedHeight: rem(168),
  declarationDrawerHeaderBackground:
    colors.components.fixedBottom.DeclarationDrawer.Background.Header,
};
